import React from 'react';
import BackButton from '../../../shared/components/back-button/BackButton';

/**
 * Payment settings sub-pages — thin wrapper around global BackButton.
 * Import BackButton directly when the label or handler differs.
 */
const BackToPaymentSettings = ({ onBack, label = 'Back to Payment Settings' }) => (
  <BackButton
    label={label}
    onClick={() => {
      if (onBack) {
        onBack('payments', 'payments');
      }
    }}
  />
);

export default BackToPaymentSettings;
